<template>
  <multi-selector v-model="self" :filterable="false" :options="selfStatusList" :remote="selfStatusSearch"></multi-selector>
</template>
<script>
import MultiSelector from '../Select';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    selfStatus: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      self: [],
      selfStatusList: []
    };
  },
  mounted() {
    this.selfStatusSearch('');
  },
  watch: {
    self() {
      this.$emit('input', this.self.map(item => item.modelCode));
    }
  },
  methods: {
    // 联系人状态下拉框
    selfStatusSearch(val) {
      this.$ajax({
        method: 'GET',
        url: '/dict/getList/benrendianhuaContactStatus',
        params: { 'val': val }
      }).then((res) => {
        res.data.map((item) => { item.title = item.modelName; return item; });
        this.selfStatusList = res.data;
        this.selfStatusList.forEach((item) => {
          if (this.selfStatus.indexOf(item.modelCode) !== -1) {
            this.self.push(item);
          }
        });
      });
    }
  },
  components: {
    MultiSelector
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness-select/SelfStatusSelector.vue